<template>
  <div>
    <el-dialog :title="$t('productDetail.addToCart')" :visible.sync="visible" width="440px">
      <div class="box">
        <div class="explain">The following items are Out of Stock. Add other available items to your shopping bag first?</div>
        <div class="list">
          <template v-for="(item, i) in list">
            <div v-if="item.skuStatus !== 1" :key="item.kkProductId+i" class="item f--c">
              <div class="img">
                <el-image fit="cover" :src="item.imageUrl"></el-image>
                <div class="sold-out">
                  <div>{{ $t('commodity.ProductDetail.SoldOut') }}</div>
                </div>
              </div>
              <div class="right f-b fd-c">
                <el-tooltip effect="dark" :content="item.productName" placement="bottom">
                  <div class="ellipsis title">{{ item.productName }}</div>
                </el-tooltip>
                <div class="f">
                  <div style="margin-right:10px">{{ item.size }} ,</div>
                  <div>SKU: {{ item.skuCode }}</div>
                </div>
                <div>{{ item.countryName }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="visible = false">{{ $t('Order.Details.Index.Cancel') }}</el-button>
        <el-button type="primary" @click="affirmAddCart">{{ $t('Order.Details.Index.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data() {
    return {
      visible: false,
      list: []
    }
  },
  methods: {
    show(list, cartParams) {
      this.visible = true
      this.list = _.cloneDeep(list).map(item => {
        let obj = { ...item }
        item.options && JSON.parse(item.options).forEach(t => {
          let attr = JSON.parse(t)
          obj[attr.name] = attr.value
        })
        return obj
      })
      this.cartParams = cartParams
    },
    affirmAddCart() {
      this.visible = false
      this.$emit('affirmAddCart', this.cartParams)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header{
  padding-bottom: 0;
}
/deep/ .el-dialog__body {
  padding: 20px 28px;
}
/deep/ .el-dialog__footer {
  padding: 28px;
  padding-top: 0;
}
.box {
  .list {
    margin-top: 12px;
    padding-bottom: 12px;
    max-height: 330px;
    overflow-y: auto;
    overflow-x: hidden;
    .item {
      height: 70px;
      margin-bottom: 8px;
      .img {
        flex-shrink: 0;
          width: 70px;
          height: 70px;
          position: relative;
        .el-image {
          width: 100%;
          height: 100%;
          border-radius: 2px;
          margin-right: 8px;
        }
        .sold-out {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          background: rgba($color: #000000, $alpha: .5);
          >div {
            position: absolute;
            font-size: 12px;
            color: #fff;
            left: 0;
            right: 0;
            bottom: 8px;
            margin: auto;
            text-align: center;
          }
        }
      }
      .right {
        height: 70px;
        width: 286px;
        padding: 6px;
        color: #909399;
        font-size: 13px;
        .title {
          color: #303133;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
